import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useLocation, useParams } from "react-router-dom";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Properties/Tables";
import EditDetail from "../../Components/Properties/EditDetail";
import ViewDetail from "../../Components/Properties/ViewDetail";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";

import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { AddExtraCharges } from "../../Components/Properties/AddExtraCharges";

const Inventory = () => {
  const { id: inventoryId } = useParams();
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("name");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [apiData, setApiData] = useState();
  const [addCharges, setAddCharges] = useState(null);
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(728, "days").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t } = useTranslation();
  const location = useLocation();

  const initialValues = {
    InventoryName: "",
    id: "",
    payuKey: "",
    payuMid: "",
    latitude: "",
    longitude: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("uId", inventoryId);
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    return await axios.post(`${Config.apiUrl}/getinventory`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getInventoriesSuccess = (res) => {
    if (res.data.status === "NOK" || res.data.data === false) error = true;
    else setApiData(res.data.data);
  };

  const getInventoriesError = (res) => {}; 

  const {
    isLoading,
    mutate: getInventoriesMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getInventoriesSuccess,
    onError: getInventoriesError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getInventoriesMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);
  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getInventoriesMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };

  //------- Edit Single Entry -------
const EditInventoryFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("inventoryName", values.inventoryName);
    body.append("mobile", values.mobile);
    body.append("status", values.status);
    body.append("uId", inventoryId);
    body.append("lockInPeriod", values.lockInPeriod);
    body.append("noticePeriod", values.noticePeriod);
    body.append("address", values.address);

    return await axios.post(`${Config.apiUrl}/editproperty`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onEditEntrySuccess = (response) => {
    const resData = response?.data;

    if (resData?.status === "OK") {
      toast.success(resData.msg || "Inventory updated successfully");

      // Update your local state with new data
      if (resData.data) {
        setApiData(resData.data);
      }
    } else {
      // Handles backend validation errors, duplicates, or general errors
      toast.error(
        resData?.msg || "An error occurred while updating the inventory"
      );
    }

    // Reset UI selections
    getInventoriesMutate();
    setSelectedData("");
    setEditUser(false);
  };

  const onEditEntryError = (error) => {
    // Handles network or unexpected errors
    setEditUser(false);
    setSelectedData("");

    // Check if backend returned a message
    const errMsg =
      error?.response?.data?.msg ||
      "An error occurred while updating the inventory";
    toast.error(errMsg);

    console.error("Edit Inventory Error:", error);
  };
  const { isLoading: editEntryLoading, mutate: editInventoryMutate } =
    useMutation(EditInventoryFunction, {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    });
  

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Inventories")}
                <span>/{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
          </div>

          {addCharges && (
            <AddExtraCharges
              setAddCharges={setAddCharges}
              data={apiData}
            />
          )}

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              t={t}
            />
          </div>
          {editUser && (
            <EditDetail
              editInventoryMutate={editInventoryMutate}
              editEntryLoading={editEntryLoading}
              setEditUser={setEditUser}
              data={data?.data}
              selectedData={selectedData}
            />
          )}

          {viewDetail && (
            <ViewDetail
              setViewDetail={setViewDetail}
              selectedData={selectedData}
            />
          )}

          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={apiData}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                userType={user.userType}
              />
              {(error || data?.data?.msg === "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");

  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[130px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    class="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    class="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>
          <div className="flex gap-4 items-end">
            {filter !== "status" && filter !== "paystatus" ? (
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="filterVal">{""}</Label>
                <Field
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  class="ml-1"
                  value={filterValue}
                  onChange={(e) => setFilterValue(e.target.value)}
                  className="border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2"
                />
              </InputGroup>
            ) : filter === "status" ? ( // Render dropdown for "Status"
              <InputGroup
                className="min-w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select")}</Label>
                <Select
                  autoComplete="off"
                  className="px-2 bg-transparent text-sm border-none"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                >
                  <MenuItem value="" disabled>
                    {t("Select Status")}
                  </MenuItem>
                  <MenuItem value="1">{t("Available")}</MenuItem>
                  <MenuItem value="2">{t("Booked")}</MenuItem>
                  <MenuItem value="3">{t("Leased")}</MenuItem>
                  <MenuItem value="4">{t("Hold")}</MenuItem>
                  <MenuItem value="6">{t("Unavailable")}</MenuItem>
                  <MenuItem value="7">{t("Delete")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null}

            <InputGroup
              className="min-w-[120px]"
              style={{ flexBasis: "content" }}
            >
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  const selectedFilter = e.target.value;
                  setFilter(selectedFilter);

                  // Prefill "KIPN" for "GId" filter
                  if (selectedFilter === "gId") {
                    setFilterValue("KIPN");
                  } else {
                    setFilterValue(""); // Clear for other filters
                  }
                }}
              >
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="status">Status</MenuItem>
              </Select>
            </InputGroup>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;

const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default Inventory;
